import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {MonitoringLevel} from '../../../core/model/MonitoringLevels.enum';
import {LimitSizeArrayModel} from '../../../core/model/helper-models/limit-size-array.model';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';
import {DataPoint} from '../../../core/model/helper-models/datapoint.model';
import {List} from 'postcss/lib/list';
import {Thing} from '../../../core/model/thing.model';


@Component({
    selector: 'app-ssagm-statistic',
    templateUrl: './ssagm-statistic.component.html',
    styleUrls: ['./ssagm-statistic.component.scss', './../card.scss'],
    standalone: false
})
export class SsagmStatisticComponent extends BaseViewElement implements OnInit, OnDestroy, OnChanges
{
    @Input() Infeeds: Array<Thing>;
    @Input() Endstellen: Array<Thing>;
    @Input() Motor: PropertySet;
    @Input() Allgemein: PropertySet;

    OperatingHours: Property<any>;
    DistanceTotal: Property<any>;
    SorterSpeed: Property<any>;
    Input: Property<any>;
    Output: Property<any>;
    Crash: Property<any>;


    sorterSpeed = new LimitSizeArrayModel<DataPoint<number>>(1000);

    constructor()
    {
        super('ssagm-statistic');
    }
    ngOnInit()
    {
        super.ngOnInit();
        if (this.Infeeds != null)
        {
            if (this.Infeeds.length > 0)
            {
                for (const infeed of this.Infeeds)
                {
                    infeed.newData.subscribe(() =>
                    {
                        this.countInfeed();
                    })
                }
            }
        }

        if (this.Endstellen != null)
        {
            if (this.Endstellen.length > 0)
            {
                for (const endstelle of this.Endstellen)
                {
                    endstelle.newData.subscribe(() =>
                    {
                        this.countEndstelle();
                    })
                }
            }
        }
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit(result);
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Motor == null) return;
        this.OperatingHours = this.Motor.properties.get('BETRIEBSSTUNDEN');


        if (this.Allgemein == null) return;
        this.DistanceTotal = this.Allgemein.properties.get('STRECKE');
        this.SorterSpeed = this.Allgemein.properties.get('SORTERGESCHWINDIGKEIT');
        this.SorterSpeed.TimeseriesData.valuePushed.subscribe(x =>
        {
            if (x != null)
            {
                this.sorterSpeed.pushDataPoint(new DataPoint(x.value / 1000, x.timestamp));
            }
        });
/*
        this.Input = this.Allgemein.properties.get('ANZ_EINSCHLEUSUNGEN');
        this.Output = this.Allgemein.properties.get('ANZ_AUSSCHLEUSUNGEN');*/
        this.Crash = this.Allgemein.properties.get('CRASH_ANZ');
    }

    // sum current datapoint of all infeeds to get max value
    private countInfeed()
    {
        let input = 0;
        let lastTimestamp: Date = new Date();
        if (this.Infeeds != null)
        {
            if (this.Infeeds.length > 0)
            {
                for (const infeed of this.Infeeds)
                {
                    if (infeed.propertySets.get('INFEED') ==  null) continue;
                    input += infeed.propertySets.get('INFEED').properties.get('ANZ_EINSCHLEUSUNGEN').TimeseriesData.currentDatapoint.value;
                    lastTimestamp = infeed.propertySets.get('INFEED').properties.get('ANZ_EINSCHLEUSUNGEN').TimeseriesData.currentDatapoint.timestamp
                }

                const dataArray = new LimitSizeArrayModel<DataPoint<any>>(1000);
                dataArray.pushDataPoint(new DataPoint(input, lastTimestamp));
                this.Input = new Property(1000, MonitoringLevel.None, dataArray);
            }
        }
    }

    // sum current datapoint of all endstelle to get max value
    private countEndstelle()
    {
        let output = 0;
        let lastTimestamp: Date = new Date();
        if (this.Endstellen != null)
        {
            if (this.Endstellen.length > 0)
            {
                for (const endstelle of this.Endstellen)
                {
                    if (endstelle.propertySets.get('ENDSTELLE') ==  null) continue;
                    output += endstelle.propertySets.get('ENDSTELLE').properties.get('ANZ_AUSSCHLEUSUNGEN').TimeseriesData.currentDatapoint.value;
                    lastTimestamp = endstelle.propertySets.get('ENDSTELLE').properties.get('ANZ_AUSSCHLEUSUNGEN').TimeseriesData.currentDatapoint.timestamp
                }

                const dataArray = new LimitSizeArrayModel<DataPoint<any>>(1000);
                dataArray.pushDataPoint(new DataPoint(output, lastTimestamp));
                this.Output = new Property(1000, MonitoringLevel.None, dataArray);
            }
        }
    }

}
